import { FC } from 'react';
import styled from 'styled-components';

import { Icon } from '@/shared/uikit/Icon';
import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { MessageActionsModalProps } from '@/widgets/modals/types';

import { ModalContainerActions } from '../containers/ModalContainerActions';

export const MessageActionsModal: FC<MessageActionsModalProps> = ({ onClick }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'messageActions' });

  const modals = useModalsStore();

  return (
    <ModalContainerActions title={t('title')}>
      <Container>
        <ButtonStyled
          onClick={() => {
            modals.closeModal();
            onClick('createTask');
          }}
          size="middle"
          type="text"
          icon={<Icon name="plus" size="s24" />}
        >
          {t('createTask')}
        </ButtonStyled>
        <ButtonStyled
          onClick={() => {
            modals.closeModal();
            onClick('reply');
          }}
          size="middle"
          type="link"
          icon={<Icon name="arrow-bend-up-left" size="s24" />}
        >
          {t('reply')}
        </ButtonStyled>
      </Container>
    </ModalContainerActions>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const ButtonStyled = styled(Button)`
  &&& {
    justify-content: flex-start;
    padding: 8px 12px;
  }
`;
